module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.voucher.cardType === '01') ? _c('div', {
    staticClass: "electron-health",
    on: {
      "click": function($event) {
        return _vm.selectVoucher(_vm.voucher)
      }
    }
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../../../static/img/icon-card-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "health-content"
  }, [_c('div', {
    staticClass: "health-content-area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-info flex-1"
  }, [_c('div', {
    staticClass: "card-info-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.voucher.holderName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("dotted")(_vm.voucher.cardNo)))])]), _vm._v(" "), _c('div', {
    staticClass: "card-info-right new_heanlth_cardItem_canvas"
  }, [_c('qrcode', {
    attrs: {
      "value": _vm.voucher.qrCode,
      "level": _vm.qrcodeLenth,
      "size": 94
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "card-logo",
    attrs: {
      "src": require("../../../static/img/card-logo.png"),
      "alt": ""
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])])]) : _c('div', {
    staticClass: "resident-health",
    on: {
      "click": function($event) {
        return _vm.selectVoucher(_vm.voucher)
      }
    }
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../../../static/img/icon-card-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "health-content"
  }, [_c('div', {
    staticClass: "health-content-area flex-col flex-justify-center f-middle"
  }, [_c('div', {
    staticClass: "flex-row flex-align-center item-row"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "item-right flex-1"
  }, [_vm._v(_vm._s(_vm.voucher.holderName))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row flex-align-center item-row"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("卡类型")]), _vm._v(" "), _c('span', {
    staticClass: "item-right flex-1"
  }, [_vm._v(_vm._s(_vm._f("cardType")(_vm.voucher.cardType)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row flex-align-center item-row"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("卡号")]), _vm._v(" "), _c('span', {
    staticClass: "item-right flex-1"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.voucher.cardNo)))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "health-content-top-tips"
  }, [_c('div', {
    staticClass: "top-tips-left"
  }, [_vm._v("\n                      四川省卫生健康委员会\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "top-tips-right"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/icon-red-ten.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("电子健康卡")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('p', [_vm._v("中华人民共和国国家卫生健康委员会监制")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65697f8c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherItem.vue
// module id = 844
// module chunks = 0